export default "__VITE_PUBLIC_ASSET__41310497__"